// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum LastpassLoginType {
  MasterPassword = 0,
  // Not sure what Types 1 and 2 are?
  Federated = 3,
}
